import React, { useState, useRef, useEffect } from 'react';
// import { DebugControls, ControlConfig } from './DebugControls';
// import { Settings, RotateCcw, Save, Download } from 'lucide-react';
// import { RotateCcw } from 'lucide-react';

interface AnimationCardProps {
  title: string;
  description: string;
  component: React.ComponentType<any>;
  // controls: ControlConfig[];
  defaultProps: Record<string, any>;
  demoClass?: string;
}

export const AnimationCard: React.FC<AnimationCardProps> = ({
  title,
  description,
  component: Component,
  // controls,
  defaultProps,
  demoClass = ''
}) => {
  // const storageKey = `reactbits-${title.toLowerCase().replace(/\s+/g, '-')}`;
  
  // Load saved props from localStorage
  // const loadSavedProps = () => {
  //   try {
  //     const saved = localStorage.getItem(storageKey);
  //     return saved ? { ...defaultProps, ...JSON.parse(saved) } : defaultProps;
  //   } catch {
  //     return defaultProps;
  //   }
  // };
  
  const [props] = useState(defaultProps);
  // const [showControls, setShowControls] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  
  // Save props to localStorage whenever they change
  // useEffect(() => {
  //   try {
  //     localStorage.setItem(storageKey, JSON.stringify(props));
  //   } catch (error) {
  //     console.warn('Could not save to localStorage:', error);
  //   }
  // }, [props, storageKey]);

  // const handleChange = (key: string, value: any) => {
  //   setProps((prev: Record<string, any>) => ({ ...prev, [key]: value }));
  // };

  // const handleRefresh = () => {
  //   setRefreshKey(prev => prev + 1);
  //   // Reset to default props, then trigger a small delay to ensure re-render
  //   // setProps(defaultProps);
  //   setTimeout(() => {
  //     setRefreshKey(prev => prev + 1);
  //   }, 50);
  // };
  
  // const handleReset = () => {
  //   setProps(defaultProps);
  //   localStorage.removeItem(storageKey);
  //   setRefreshKey(prev => prev + 1);
  // };
  
  // const handleExport = () => {
  //   const config = {
  //     animation: title,
  //     settings: props,
  //     timestamp: new Date().toISOString()
  //   };
  //   const blob = new Blob([JSON.stringify(config, null, 2)], { type: 'application/json' });
  //   const url = URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = `${title.toLowerCase().replace(/\s+/g, '-')}-settings.json`;
  //   a.click();
  //   URL.revokeObjectURL(url);
  // };

  return (
    <div className="card">
      <div className="card-header" style={{ marginBottom: '8px' }}>
        <h3 className="card-title">{title}</h3>
      </div>
      
      <p className="card-description">{description}</p>
      
      <div className={`demo-area ${demoClass}`}>
        <Component key={refreshKey} {...props} />
      </div>
      
      {/* Alle Buttons entfernt - kontinuierliche Loops ohne Interaktion */}
      
      {/* Debug controls panel auskommentiert */}
      {/*
      {showControls && (
        <DebugControls
          controls={controls}
          values={props}
          onChange={handleChange}
        />
      )}
      */}
    </div>
  );
};